import { Center, Group, Loader, Text } from '@mantine/core';

type props = {
  showText?: boolean;
};

const FullPageSpinner = ({ showText = true }: props) => {
  return (
    <Center style={{ width: '100vw', height: '100vh' }}>
      <Group gap="xs">
        <Loader size="xs" />
        {showText && <Text>Loading...</Text>}
      </Group>
    </Center>
  );
};

export default FullPageSpinner;
